export default "__VITE_ASSET__CCmc6FQT__"